import styled from "styled-components";
import Sidebar from "./Sidebar";
import ViewSelector from "./ViewSelector";
import Filters from "./Filters";
import { useEffect } from "react";
import { getWindowHeight } from "../utils";

export default function AppContainer(props: { children: any; page?: string }) {
  useEffect(() => {
    window.sessionStorage.setItem("main-page", props.page || "");
  }, [props.page]);
  return (
    <Container>
      <Sidebar />
      <BodyContainer>
        <Header>
          <ViewSelector />
          <Filters />
        </Header>
        <Body>{props.children}</Body>
      </BodyContainer>
    </Container>
  );
}

/*
 Styled components
*/
const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  overflow: hidden;
`;
const BodyContainer = styled.div`
  overflow: hidden;
  flex-grow: 1;
`;
const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 24px 0px 43px 0px;
  width: 100%;
`;
const Body = styled.div`
  height: calc(${getWindowHeight()} - 122px);
  width: 100%;
  display: normal;
  overflow: hidden;
`;
